import React from 'react';
import { Heading, Flex } from '@chakra-ui/react';
import { ChangePasswordForm } from './ChangePasswordForm';
import { FormWrapper } from 'components';
import { ReactComponent as UnlockedImage } from 'assets/unlocked.svg';
import { AuthenticatedLayout } from 'layouts';

const ChangePassword: React.FC = () => {
  return (
    <AuthenticatedLayout>
      <Flex
        gap={8}
        direction="column"
        alignItems="center"
        justifyContent="center"
        height="100%"
      >
        <FormWrapper
          aboveForm={
            <Heading as="h1" size="lg" textAlign="center">
              Change Your Password
            </Heading>
          }
          form={<ChangePasswordForm />}
          formImage={<UnlockedImage height="100%" />}
        />
      </Flex>
    </AuthenticatedLayout>
  );
};

export default ChangePassword;
